import {Component, Input, OnChanges, OnDestroy, OnInit, QueryList, SimpleChanges, ViewChildren} from '@angular/core';
import {EditModalSectionBaseComponent} from '../edit-modal-section-base.component';
import {EditModalService} from '../../../services/edit-modal.service';
import {MyNotDeviceRequestContainerModel} from '../../../models/my-not-device-request-container.model';
import {ProductCategoryTypeEnum} from '../../../enums/product-category-type.enum';
import {MyDeviceRequestContainerModel} from '../../../models/my-device-request-container.model';
import {ControlContainer, NgForm, NgModel} from '@angular/forms';
import {Subscription} from 'rxjs';
import {EnumUtils} from '../../../utils/enum.utils';
import {ProjectUpdateNotificationFieldEnum} from '../../../enums/project-update-notification-field.enum';
import {MyContainersTableIdEnum} from '../../../enums/my-containers-table-id.enum';
import {AddAdditionalItemToOrderModalComponent} from '../../add-additional-item-to-order-modal/add-additional-item-to-order-modal.component';
import {IModalDialogV3} from '../../../../../shared-modal-dynamic/interfaces/i-modal-dialog-v3';
import {ModalDynamicV3Service} from '../../../../../shared-modal-dynamic/services/modal-dynamic-v3-service.service';


@Component({
    selector: 'app-projects-additional-items-table',
    templateUrl: './additional-items-table.component.html',
    styleUrls: ['./additional-items-table.component.scss'],
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})

// used on 5. step  to list  accessories, warranties and Upgrades items
export class ProjectAdditionalItemsTableComponent extends EditModalSectionBaseComponent implements OnInit, OnChanges, OnDestroy {

    @Input() public forceFormValidationVisibility: boolean;
    @Input() title: string;
    @Input() tableId: MyContainersTableIdEnum;

    public MyContainersTableIdEnum = MyContainersTableIdEnum;

    public activeSpinnerId = '';
    public spinnerId = 'newSpinnerId';
    private spinnerSubscription: Subscription;

    private changesSub: Subscription;

    private warningLogged = false;

    @ViewChildren('dynamicInput') dynamicInputs: QueryList<NgModel>;
    private tableDataSourceChangedSubscription: Subscription;

    @Input() public tableItems: MyNotDeviceRequestContainerModel[];


    constructor(
        public  editModalService: EditModalService,
        private modalDynamicV3Service: ModalDynamicV3Service) {
        super(editModalService);

        this.tableDataSourceChangedSubscription =
            this.editModalService.tableContentChangedAnnounced$.subscribe(announcedTableId => {
                if (announcedTableId === this.tableId || announcedTableId === MyContainersTableIdEnum.allTablesContainers) {
                    this.activateTableValidators();
                }
            });
    }

    ngOnInit() {
        super.ngOnInit();
    }

    onRemoveItemsFromOrderBtnLicked() {
        switch (this.tableId) {
            // case MyContainersTableIdEnum.DEVICES:
            //     this.model.isDeviceOrderRequested = false;
            //     break;
            case MyContainersTableIdEnum.step4AccessoriesTableContainers:
                this.model.isAccessoryOrderRequested = false;
                break;
            case MyContainersTableIdEnum.step4WarrantiesTableContainers:
                this.model.isWarrantyOrderRequested = false;
                break;
            case MyContainersTableIdEnum.step4UpgradesContainers:
                this.model.isUpgradesOrderRequested = false;
                break;
            default:
                console.warn('unexpected table type enum value ', MyContainersTableIdEnum[this.tableId], this.tableId);
        }
        this.editModalService.announceTableContentChanged(this.tableId);
    }

    onAddProductBtnClicked() {

        const dialogRef: IModalDialogV3 = this.modalDynamicV3Service
            .open(AddAdditionalItemToOrderModalComponent, {
                model: {
                    hideSpinner: true,
                    parentTableId: this.tableId
                }
            });
        dialogRef.subscribe((val: { containers: MyDeviceRequestContainerModel[], action: 'SUBMIT' | 'RESET' }) => {
            this.HandleAddProductsNrToOrderModalResult(val, dialogRef);
        });

    }

    projectRowItemsAmountComplyRules() {
        return this.editModalService.projectContainsAnythingToOrder();
    }

    public tableHasRequestedItems(): boolean {
        return !!(this.tableItems && this.tableItems.length);
    }

    public isWarrantyProductType(itemContainer: MyNotDeviceRequestContainerModel): boolean {
        return ProductCategoryTypeEnum[itemContainer.itemToOrder.category] === ProductCategoryTypeEnum.WARRANTY;
    }

    public onRemoveItemBtnClicked(itemContainer: MyDeviceRequestContainerModel | MyNotDeviceRequestContainerModel) {
        itemContainer.containerSharedMetadata.addToProductOrderList = false;
        // this.editModalService.refreshRequestedDeviceContainers();
        // this.editModalService.announceTableContentChanged(this.tableId);
        this.editModalService.refreshRequestedNotSupplyNotServicesNotCustomContainers(this.tableId);
    }

    private activateTableValidators() {
        if (!this.changesSub) {
            this.changesSub = this.dynamicInputs.changes.subscribe(value => {

                setTimeout(_ => {
                    // console.log('updating validators', value);
                    (value as QueryList<NgModel>).forEach(item => item.control.updateValueAndValidity());
                }, 0);
                this.changesSub.unsubscribe();
                this.changesSub = undefined;
            });
        }
    }

    public ngOnChanges(changes: SimpleChanges): void {
        this.spinnerId = EnumUtils.getKeyByValue(MyContainersTableIdEnum, this.tableId);
    }

    public ngOnDestroy(): void {
        if (this.changesSub) {
            this.changesSub.unsubscribe();
        }

        if (this.spinnerSubscription) {
            this.spinnerSubscription.unsubscribe();
        }
        if (this.tableDataSourceChangedSubscription) {
            this.tableDataSourceChangedSubscription.unsubscribe();
        }
    }

    public notifyAdditionalItemsTableChange() {
        let fieldId: ProjectUpdateNotificationFieldEnum;

        switch (this.tableId) {
            case MyContainersTableIdEnum.step4AccessoriesTableContainers:
                fieldId = ProjectUpdateNotificationFieldEnum.PRODUCTS;
                break;
            case MyContainersTableIdEnum.step4WarrantiesTableContainers:
                fieldId = ProjectUpdateNotificationFieldEnum.PRODUCTS;
                break;
            case MyContainersTableIdEnum.step4UpgradesContainers:
                fieldId = ProjectUpdateNotificationFieldEnum.PRODUCTS;
                break;
            default:
                console.warn('unexpected table type enum value', MyContainersTableIdEnum[this.tableId]);
        }

        return this.editModalService.showChangeNotification(fieldId);
    }

    private HandleAddProductsNrToOrderModalResult(
        val: { containers: MyDeviceRequestContainerModel[], action: 'SUBMIT' | 'RESET' },
        dialogRef: IModalDialogV3) {

        if (val.action === 'SUBMIT') {
            this.editModalService.refreshRequestedNotSupplyNotServicesNotCustomContainers(this.tableId);
        } else {
            // val.action === 'RESET'
            this.editModalService.resetRequestedProductContainersChanges();
        }

        this.activeSpinnerId = ''; // just for sure, in the IE the spinner deactivating via dialog sometime does not work

        this.editModalService.updateActiveProjectContainerExistenceValidationHelperStatus();
        this.activateTableValidators();
    }

    public isInfoIconVisible() {
        return this.tableId === MyContainersTableIdEnum.step4UpgradesContainers;
    }

    public getInfoIconText(): string {
        return 'Die Brother Upgrades erweitern schnell und einfach den Funktionsumfang ausgewählter Drucker und Dokumentenscanner. Detaillierte Informationen erhalten Sie über www.brother.de oder über Ihren Brother Ansprechpartner.';
    }

}
